import axios from './axiosBase'
import { baseUrl } from './api'

const AUTH = process.env.REACT_APP_AUTHENTICATOR_AUTH

export async function login(formData) {
  return axios({
    method: 'POST',
    url: `${baseUrl}/login`,
    headers: {
      'x-api-key': AUTH,
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Request-Origin': 'PANEL',
    },
    data: formData,
    validateStatus: (status) => status >= 200 && status <= 302,
  })
}

export async function requestRecoverPassword(formData) {
  return axios({
    method: 'POST',
    url: `${baseUrl}/password-recover`,
    headers: {
      'X-Request-Origin': 'PANEL',
    },
    data: formData,
  })
}

export async function verifySignature(signature) {
  return axios({
    method: 'POST',
    url: `${baseUrl}/signature/validate`,
    headers: {
      'X-Request-Origin': 'PANEL',
    },
    data: signature,
  })
}


export async function submitNewPassword(token, formData) {
  return axios({
    method: 'POST',
    url: `${baseUrl}/password-create`,
    data: formData,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-Request-Origin': 'PANEL',
    },
  })
}
